import React, { Component } from 'react';
import { FA } from './FA';

class Saved extends Component {
  render() {
    if(!this.props.saved) {
      return (<span></span>);
    }
    return (
      <div className="pull-right saved">
        Saved <FA name="check" />
      </div>
    );
  }
}

export { Saved };
